import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import BulkTaggingModal from 'components/modals/bulk_tagging_modal';

import { bulkTagging, endBulkTagging, setBulkTags } from "../../store/actions/properties";

export class Properties1BulkTaggingModal extends React.Component {

  static propTypes = {
    bulkTags: PropTypes.array.isRequired,
    selectedPropertyIds: PropTypes.array.isRequired,
    startBulkTagging: PropTypes.bool.isRequired,
    tagsPaths: PropTypes.object.isRequired,
    onBulkTagging: PropTypes.func.isRequired,
    onCancelBulkTagging: PropTypes.func.isRequired,
    onSetBulkTags: PropTypes.func.isRequired,
  };

  render() {
    const {
      bulkTags,
      onSetBulkTags,
      selectedPropertyIds,
      startBulkTagging,
      tagsPaths,
      onBulkTagging,
      onCancelBulkTagging
    } = this.props;

    const count = selectedPropertyIds.length;

    return (
      <BulkTaggingModal
        buttonText={"Bulk Tag " + count + (count > 1 ? " Properties" : " Property")}
        paths={tagsPaths}
        selectedIds={selectedPropertyIds}
        shown={startBulkTagging}
        tags={bulkTags}
        onBulkTag={onBulkTagging}
        onCancel={onCancelBulkTagging}
        onSetBulkTags={onSetBulkTags}
      />
    );
  }
}

const mapStateToProps = state => ({
  bulkTags: state.properties.bulkTags,
  startBulkTagging: state.properties.startBulkTagging,
  selectedPropertyIds: state.selectList.selectedPropertyIds,
  tagsPaths: state.paths.tags
});

const mapDispatchToProps = {
  onBulkTagging: bulkTagging,
  onCancelBulkTagging: endBulkTagging,
  onSetBulkTags: setBulkTags,
};

export default connect(mapStateToProps, mapDispatchToProps)(Properties1BulkTaggingModal);
